<div
  class="stepper-title title-2"
  [class.stepper-title--dark]="isDarkMode"
  [class.stepper-title--light]="isLightMode"
>
  <ol class="stepper-title__list">
    <li
      *ngFor="let step of steps; index as i"
      class="stepper-title__list__item"
      [class.stepper-title__list__item--before]="i < active"
      [class.stepper-title__list__item--active]="i === active"
    >
      {{ step }}
    </li>
  </ol>
  <div class="stepper-title__title">
    <ng-content></ng-content>
  </div>
</div>
